import { TableHeadersType } from '../tableHeadersType';

export const HELP_MODULE_HEADERS: TableHeadersType[] = [
  {
    "label": "TITLE",
    "value": "title",
  
  },
  {
    "label": "DESCRIPTION",
    "value": "description",
  },
  {
    "label": "MODIFIED BY",
    "value": "created_by",
  },
  // {
  //   "label": "ADDED By",
  //   "value": "created_by",
  // },
  {
    "label": "FILE ATTACHED",
    "value": "attachments",
  },
  {
    "label": "video ATTACHED",
    "value": "video_link",
  },
//    {
//     "label": "ACTION",
//     "value": "edit",
//   },
];